module.exports = "<deductionplans-page></deductionplans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/deductions.html
// module id = 1679
// module chunks = 0